import { useStudentPaymentMethodAddedSuspenseQuery } from '@lingoda/monolith-graphql';
import { isSubscriptionFFreeTrial } from '../utils/isSubscriptionFFreeTrial';

export const useIsFFreeTrial = () => {
    const { data } = useStudentPaymentMethodAddedSuspenseQuery({
        fetchPolicy: 'cache-and-network',
    });

    return isSubscriptionFFreeTrial(data?.subscriptions?.currentSubscription);
};
